import React from 'react';
import { AiOutlineDelete, AiOutlinePlus } from "react-icons/ai";
import { FiTool, FiInfo } from "react-icons/fi";

const SkillsForm = ({ formData, setFormData }) => {
  const handleSkillChange = (index, field, value) => {
    const newSkills = [...formData.skills];
    newSkills[index][field] = value;
    setFormData({ ...formData, skills: newSkills });
  };

  const handleItemChange = (skillIndex, itemIndex, value) => {
    const newSkills = [...formData.skills];
    newSkills[skillIndex].items[itemIndex] = value;
    setFormData({ ...formData, skills: newSkills });
  };

  const addSkill = () => {
    setFormData(prevState => ({
      ...prevState,
      skills: [...prevState.skills, { title: '', items: [''] }]
    }));
  };

  const addItem = (skillIndex) => {
    const newSkills = [...formData.skills];
    newSkills[skillIndex].items.push('');
    setFormData({ ...formData, skills: newSkills });
  };

  const removeSkill = (skillIndex) => {
    const newSkills = formData.skills.filter((_, index) => index !== skillIndex);
    setFormData({ ...formData, skills: newSkills });
  };

  const removeItem = (skillIndex, itemIndex) => {
    const newSkills = [...formData.skills];
    newSkills[skillIndex].items = newSkills[skillIndex].items.filter((_, index) => index !== itemIndex);
    setFormData({ ...formData, skills: newSkills });
  };

  return (
    <div className="form-section">
      <div className="helper-text" style={{ marginBottom: 'var(--space-lg)' }}>
        <FiInfo className="helper-icon" />
        Organize your skills into categories (e.g., Programming Languages, Tools, Soft Skills)
      </div>

      {formData.skills.map((skill, skillIndex) => (
        <div key={skillIndex} className="skill-category" data-index={skillIndex + 1}>
          <div className="form-group">
            <label className="input-label">
              <FiTool style={{ display: 'inline', marginRight: '0.5rem' }} />
              Skill Category
            </label>
            <input
              className='text-input'
              type="text"
              placeholder="e.g., Programming Languages"
              value={skill.title}
              onChange={(e) => handleSkillChange(skillIndex, 'title', e.target.value)}
            />
          </div>

          <div className="section-divider"></div>

          <label className="input-label" style={{ marginBottom: 'var(--space-md)' }}>
            Skills
          </label>
          
          <div className="skill-items-grid">
            {skill.items.map((item, itemIndex) => (
              <div key={itemIndex} className="skill-tag-input">
                <input
                  className='text-input'
                  type="text"
                  placeholder="e.g., JavaScript"
                  value={item}
                  onChange={(e) => handleItemChange(skillIndex, itemIndex, e.target.value)}
                />
                {skill.items.length > 1 && (
                  <button
                    className='skill-remove-btn'
                    type="button"
                    onClick={() => removeItem(skillIndex, itemIndex)}
                    title="Remove skill"
                  >
                    <AiOutlineDelete />
                  </button>
                )}
              </div>
            ))}
          </div>

          <div className="button-group">
            <button 
              className='add-button' 
              type="button" 
              onClick={() => addItem(skillIndex)}
            >
              <AiOutlinePlus />
              Add Skill
            </button>
            
            <button 
              className='remove-button' 
              type="button" 
              onClick={() => removeSkill(skillIndex)}
            >
              <AiOutlineDelete />
              Remove Category
            </button>
          </div>
        </div>
      ))}

      <button 
        className='add-button-large' 
        type="button" 
        onClick={addSkill}
      >
        <AiOutlinePlus />
        Add New Skill Category
      </button>
    </div>
  );
};

export default SkillsForm;